export const identity = <T>(t: T) => t;
